import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgChevronLeft(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2891 4.2968C14.6796 4.68749 14.6796 5.32092 14.2891 5.71161L8 12.0038L14.2891 18.296C14.6796 18.6867 14.6796 19.3201 14.2891 19.7108C13.8986 20.1015 13.2654 20.1015 12.8749 19.7108L6.58579 13.4186C5.80474 12.6372 5.80474 11.3704 6.58579 10.589L12.8749 4.2968C13.2654 3.90611 13.8986 3.90611 14.2891 4.2968Z", fill: "currentColor" })));
}
export default SvgChevronLeft;
